
import axios from '../config/axios';

export const url = '/api/contactogeneralqy179'


export const createcontactogeneralqy179 = ({
  token,
	dnid66h9,
	nombrecompletolfmi2,
	correoeletrnico28d5p,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && dnid66h9 && correoeletrnico28d5p ) {

    axios.post(`${url}//create/basic/69118ba3e307249250074a11`, {
		dnid66h9,
		nombrecompletolfmi2,
		correoeletrnico28d5p,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!dnid66h9) {
		reject({
			status: 'error',
			info: 'DNI no esta definido',
		});
	}  else if (!correoeletrnico28d5p) {
		reject({
			status: 'error',
			info: 'Correo eletrónico no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

